export default __webpack_public_path__ + "static/media/AdPirates_08.473436c2.png";